import { render } from "./tag-list-collapsible.vue?vue&type=template&id=f0fb1dda&ts=true"
import script from "./tag-list-collapsible.ts?vue&type=script&lang=ts"
export * from "./tag-list-collapsible.ts?vue&type=script&lang=ts"

import "./tag-list-collapsible.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__